var _filter, _filter2, _rect, _text, _text2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeflowCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 620",
    width: 1100,
    height: 620,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "catBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8fafc"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "catHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ea580c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f97316"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "catShadow",
    x: "-15%",
    y: "-15%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 16,
    floodColor: "#0f172a",
    floodOpacity: 0.12
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "cardSoftShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 6,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1100,
    height: 620,
    rx: 16,
    fill: "url(#catBg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 46,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1e293b",
    textAnchor: "middle"
  }, "Extensive Node Library")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 72,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fill: "#64748b",
    textAnchor: "middle"
  }, "80+ production-ready nodes organized by industrial function")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,100)",
    filter: "url(#catShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 460,
    rx: 14,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 46,
    rx: 14,
    fill: "url(#catHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32,
    width: 260,
    height: 14,
    fill: "url(#catHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDCDA Node Library"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,62)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#fff7ed",
    stroke: "#fed7aa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#c2410c"
  }, "\u25BE Trigger")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 Common")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 Logical")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 Expressions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#fff7ed",
    stroke: "#fed7aa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#c2410c"
  }, "\u25BE MQTT")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 Database")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 API Services")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,370)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 Scripting")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 36,
    rx: 6,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#475569"
  }, "\u25B8 MES / EMS")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,100)",
    filter: "url(#catShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 460,
    rx: 14,
    fill: "#fafafa",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 36,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#475569",
    textAnchor: "middle"
  }, "Workflow Canvas"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,80)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u25B6"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Trigger"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#dbeafe"
  }, "Cron / Event")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,80)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Condition"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#ede9fe"
  }, "If / Else")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(500,80)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "{}"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Script"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#fce7f3"
  }, "JavaScript")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170,210)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#14b8a6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDDC4"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Database"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#ccfbf1"
  }, "SQL Logger")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390,210)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDCE1"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "MQTT"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#fef3c7"
  }, "Publish")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,340)",
    filter: "url(#cardSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 64,
    rx: 10,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83C\uDFED"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Machine"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#d1fae5"
  }, "MES Node")), /*#__PURE__*/React.createElement("path", {
    d: "M210 112 L280 112",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 112 L500 112",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 144 L355 180 L245 180 L245 210",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 144 L355 180 L465 180 L465 210",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 274 L245 310 L355 310 L355 340",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 274 L465 310 L355 310 L355 340",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 112,
    r: 4,
    fill: "#4680ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 112,
    r: 4,
    fill: "#4680ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 112,
    r: 4,
    fill: "#4680ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 112,
    r: 4,
    fill: "#4680ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeflowCategories);
export default __webpack_public_path__ + "static/media/nodeflow_categories.d53710f2533defe146a157208575894f.svg";
export { ForwardRef as ReactComponent };